const { serialize } = require("../../utils");

export default {
  namespaced: true,
  state: {
    path: "aljabr/hr",
  },
  actions: {
    getOffers({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/offers?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    createOffer({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/offers/create`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    updateOffer({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/offers/update`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    deleteOffer({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/offers/delete`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    getApplications({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/applications?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    getApplication({ dispatch, state, rootState }, id) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/applications/${id}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    updateApplicationStatus({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/applications/update-status`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    approveBotAccess({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/applications/approve-bot-access`, method: "POST", data }, { root: true });
      }
    },
    requestDocuments({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/applications/request-documents`, method: "POST", data }, { root: true });
      }
    },
    reviewDocument({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/applications/review-document`, method: "POST", data }, { root: true });
      }
    },
    addApplicationNote({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/applications/add-note`, method: "POST", data }, { root: true });
      }
    },
    getDocumentFile({ dispatch, state, rootState }, { id, key }) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/applications/document-file/${id}/${key}`, method: "GET", data: {} }, { root: true });
      }
    },
  },
};


